import { createSlice } from '@reduxjs/toolkit';

const notification = createSlice({
    name: 'notification',
    initialState: {
        isError: false,
        errorText: '',
        isWarning: false,
        warningText: '',
        isSuccess: false,
        successText: '',
    },
    reducers: {
        setIsError(state, action) {
            state.isError = !state.isError
            state.errorText = action.payload
        },
        setIsWarning(state,action){
            state.isWarning = !state.isWarning
            state.warningText = action.payload
        },
        setIsSuccess(state, action) {
            state.isSuccess = !state.isSuccess
            state.successText = action.payload
        },
    }
})

export default notification.reducer
export const { setIsError, setIsSuccess, setIsWarning } = notification.actions;
